// extracted by mini-css-extract-plugin
module.exports = {"wrapper-link":"styles__wrapper-link__2jUy9","wrapperLink":"styles__wrapper-link__2jUy9","title":"styles__title__1IS57"};